import { Component, OnInit } from "@angular/core";
import { showIntercom } from "../../util/intercom.util";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  language: string;

  constructor(private translate: TranslateService,
              private route: ActivatedRoute) {
  }

  async ngOnInit() {
    this.language = this.translate.getCurrentLang();
    if (this.route.snapshot.routeConfig.path === "chat") {
      setTimeout(() => {
        showIntercom();
      }, 500);
    }
  }
}
